import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  Tooltip,
} from '@material-ui/core/'

class TooltipButton extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    tooltipTitle: PropTypes.string,
  }

  static defaultProps = {
    tooltipTitle: '',
  }

  render() {
    const { children, tooltipTitle, ...props } = this.props

    return (
      <Tooltip title={tooltipTitle} disableFocusListener>
        <Button {...props}>
          { children }
        </Button>
      </Tooltip>
    )
  }
}

export default TooltipButton
